import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { selfMergeDPRoot } from '../self-merge-route.locs';

const feature = HubFeature.MergeCandidatesCandidateSelfMerge;

export type SelfMergeValidateLocs =
	| 'CPSelfMergeValidateSectionTitle'
	| 'CPSelfMergeValidateSuccess'
	| 'CPSelfMergeValidateError';
export const selfMergeValidateLocs: LocDefs<SelfMergeValidateLocs> = {
	CPSelfMergeValidateSectionTitle: {
		defaultValue: 'Verifying Merge Request',
		description: 'Section title for the candidate self merge validation page.',
		displayPath: `${selfMergeDPRoot}|Validation|Section Title`,
		displayType: 'Title',
		feature,
		portal: 'CP',
	},
	CPSelfMergeValidateSuccess: {
		defaultValue: 'You have successfully merged accounts.',
		description: 'Message displayed after successfully validating the merge request.',
		displayPath: `${selfMergeDPRoot}|Validation|Success`,
		displayType: 'Content',
		feature,
		portal: 'CP',
	},
	CPSelfMergeValidateError: {
		defaultValue: 'There was a problem merging the requested account. Please contact support.',
		description: 'Message displayed after an error occurred validating the merge request.',
		displayPath: `${selfMergeDPRoot}|Validation|Error`,
		displayType: 'Content',
		feature,
		portal: 'CP',
	},
};

export type SelfMergeValidateLocType = LocMap<SelfMergeValidateLocs>;
export const LOC_KEYS = MapLocKeys<SelfMergeValidateLocs>(selfMergeValidateLocs);
